export const popupMenuOptions = {
    valid: {
        // turning on or off card status
        CardTurnOnOff: "CardTurnOnOff",
        // reset existing PIN
        ResetPIN: "ResetPIN",
        ReplaceCard: "ReplaceCard",
        CancelExistingTravelExemption: "CancelExistingTravelExemption"
    },
    invalid: {
        // card status not active
        CardStatusInvalid: "CardStatusInvalid",
        ReplaceCardSuspiciousActivity: "ReplaceCardSuspiciousActivity",
        // Type used to display an ineligible message when a user tries to request a travel exemption on an ineligible card
        IneligibleTravelExemption: "IneligibleTravelExemption",
        // Type used to display an existing travel exemption if there is one
        ExistingTravelExemption: "ExistingTravelExemption",
        // Type used to display an ineligible message when a user tries to request a replacement on an ineligible card
        IneligibleReplaceCard: "IneligibleReplaceCard"
    },
    other: {
      // Type used to request a travel exemption on an eligible card
      // This will lead the user to a unique travel exemption flow
      EligibleTravelExemption: "EligibleTravelExemption",
    },
};


// WEBPACK FOOTER //
// ./src/components/card-controls/parent/data/popupMenuOptions.js